import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { GridApi, ICellRendererParams } from 'ag-grid-community';
import { UserModalComponent } from './user-modal/user-modal.component';
import { RolesService } from '../roles.service';
import { ConfirmDialogComponent, ConfirmDialogData } from '../confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cell-renderer',
  template: `<span matTooltip="View User Details"><a matTooltip="View User Details" [attr.href]="getUserDetailsLink()"><i class="fa-solid fa-eye"></i></a></span>`,
})
export class ViewUserManagerDetailsComponent implements ICellRendererAngularComp {

  params: any;

  constructor(private router: Router) { }

  getUserDetailsLink(): string {
    return `/user_details/${this.params.data.id}`;
  }

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    return false;
  }

}

@Component({
  selector: 'app-delete-cell-renderer',
  template: `<span matToolTip="Disable User"><i class="fa-solid fa-trash" (click)="deleteUser()"></i></span>`
})
export class DisableUserComponent implements ICellRendererAngularComp {
  params: any;
  constructor(public dialog: MatDialog, private http: HttpClient, private toastr: ToastrService){} 
  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
  }
  refresh(params: ICellRendererParams<any, any, any>): boolean {
    return true;
  }
  deleteUser(){
            console.log(this.params.data)
    setTimeout(() => {
      if (this.params.data.id){
        const dialogData: ConfirmDialogData = {
          title: 'Disable User',
          message: `Are you sure you want to delete ${this.params.data.api_username || this.params.data.id}'s user?`,
          confirmText: 'Yes',
          cancelText: 'Cancel'
        };
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '350px',
          data: dialogData,
          autoFocus: true,
          restoreFocus: false
        });

        dialogRef.afterClosed().subscribe((result) => {
          if(result){
            console.log('You have agreed to delete this user');
            const url = "/api/users/disable_user.php";
            const postBody = { id: this.params.data.id } ;
            
            this.http.post<any>(url, postBody).subscribe(
              res => {
                if(res['code'] && res['code'] == 200){
                  this.toastr.success('User successfully disabled');
                }
                else{
                  this.toastr.error('User could not be disabled');
                  console.log(res);
                }
              }, error => {
                console.warn(error);
                this.toastr.error('User could not be disabled');
              }
            )
          }
          else{
            console.log('You have not agreed to delete this user');
          }
        })
      }
      else{
      }

    })
  }
}

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  private gridApi!: GridApi;
  hasPageAccess: boolean = false
  users!: any[];
  apiUsers!: any[];
  filterUsername: string = '';
  filterRole: string = '';
  filterStatus: string = '';
  roleList: string[] = ['All', 'Super Admin', 'Carrier', 'Master'];
  statusList: string[] = ['All', 'Enabled', 'Disabled'];
  roleMap: { [key: string]: string } = {
    "262144": "Super Admin",
    "4194304": "Carrier",
    "8388608": "Master",
    "16777216": "Customer",
    "1": "Admin",
    "8192": "Manager",
    "4096": "Finance",
    "32768": "Operations",
    "65536": "Sales",
    "256": "Dispatcher",
    "2": "Agent",
    "4": "Customer Care",
    "512": "Driver",
  };

  roles: { [key: string]: number } = {
    ADMIN: 1,
    AUTHOR: 2,
    COLLABORATOR: 4,
    CONSULTANT: 8,
    CONSUMER: 16,
    CONTRIBUTOR: 32,
    COORDINATOR: 64,
    CREATOR: 128,
    DEVELOPER: 256,
    DIRECTOR: 512,
    EDITOR: 1024,
    EMPLOYEE: 2048,
    MAINTAINER: 4096,
    MANAGER: 8192,
    MODERATOR: 16384,
    PUBLISHER: 32768,
    REVIEWER: 65536,
    SUBSCRIBER: 131072,
    SUPER_ADMIN: 262144,
    SUPER_EDITOR: 524288,
    SUPER_MODERATOR: 1048576,
    TRANSLATOR: 2097152,
    CARRIER: 4194304,
    MASTER: 8388608,
    CUSTOMER: 16777216,
    SHIPPER: 33554432,
    CONSIGNEE: 67108864,
    SHIPPING_RECEIVING: 134217728,
    AGENT: 268435456,
    CUSTOMER_CARE: 536870912,
    DISPATCHER: 1073741824,
    DRIVER: 2147483648,
    FINANCE: 4294967296,
    OPERATIONS: 8589934592,
    SALES: 17179869184
  };

  constructor(private http: HttpClient, private dialog: MatDialog, private rolesService: RolesService) { }

  // Example usage
  userRole = 512; // Example user role
  pageRoleAccess = 4075; // Example page role access

  // Function to check access
  hasAccess(userRole: number, pageRoleAccess: number): boolean {
    // Perform bitwise AND operation to check if the user's role has access to the page
    console.log(userRole & pageRoleAccess)
    return (userRole & pageRoleAccess) !== 0;
  }

  ngOnInit(): void {
    this.rolesService.getRolesMask();
    // let test = this.rolesService.hasAccess(4075);
    // console.log('test', test)

    this.rolesService.hasAccess(4075).subscribe(result => {
      console.log('Access result:', result);
      this.hasPageAccess = result
    });

     // Check if the user has access to the page
     if (this.hasAccess(this.userRole, this.pageRoleAccess)) {
      console.log("Role", "User has access to the page.");
    } else {
      console.log("Role", "User does not have access to the page.");
    }
    const url = "/api/users/users.php"
    this.http.get(url).subscribe((response: any) => {
      if (response) {
        console.log('users:', response);
        this.users = response;
      }
    })

    this.http.get("/api/users/users.php", { params: { type: 'apiDatabase' } }).subscribe((response: any) => {
      if (response) {
        console.log('api users:', response.data);
        this.apiUsers = response.data;
      }
    })
  }

  userColumnDefs = [
    { field: 'id', headerName: 'ID', width: 100, },
    { field: 'domain_name', headerName: 'Domain Name', width: 250, },
    { field: 'email', headerName: 'Email', width: 260, },
    { field: 'api_key', headerName: 'API Key', width: 350, },
    {
      field: 'registered', headerName: 'Created', width: 200, valueGetter: (params: any) => {
        const timestampString: string = params.data.registered; // Replace this with your timestamp string
        const timestamp: number = parseInt(timestampString, 10);
        const date: Date = new Date(timestamp * 1000); // Convert to milliseconds

        // Check if the date is valid before formatting
        if (!isNaN(date.getTime())) {
          const formattedDate: string = date.toISOString().slice(0, 19).replace('T', ' '); // Y-m-d H:i:s format
          return formattedDate;
        } else {
          return '';
        }
      },
    },
    {
      field: 'last_login', headerName: 'Last Login', width: 200, valueGetter: (params: any) => {
        const timestampString: string = params.data.last_login; // Replace this with your timestamp string
        const timestamp: number = parseInt(timestampString, 10);
        const date: Date = new Date(timestamp * 1000); // Convert to milliseconds

        // Check if the date is valid before formatting
        if (!isNaN(date.getTime())) {
          const formattedDate: string = date.toISOString().slice(0, 19).replace('T', ' '); // Y-m-d H:i:s format
          return formattedDate;
        } else {
          return '';
        }
      },
    },
    {
      field: 'roles_mask', headerName: 'Role', width: 150, valueGetter: (params: any) => {
        return this.getRoleDescription(params.data.roles_mask);
      },
    },
    {
      field: 'status', headerName: 'Status', width: 150, valueGetter: (params: any) => {
        if (params.data.status == '0') {
          return 'Enabled';
        } else {
          return 'Disabled';
        }
      },
    },
    { headerName: 'Action', width: 100, /*cellRendererFramework: ViewUserManagerDetailsComponent,*/ cellRenderer: ViewUserManagerDetailsComponent },
    { headerName: 'Delete', width: 100, cellRenderer: DisableUserComponent, editable: false}
  ]

  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
    editable: true,
  };

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi = params.api;
  }

  //Get Actual Role based on role_mask
  getRoleDescription(role: string): string {
    return this.roleMap[role] || "Multi Roles";
  }

  onInputChange() {
    if (this.gridApi) {
      // Set filter model dynamically based on the username value
      const filterModel = {
        email: { type: 'contains', filter: this.filterUsername },
        roles_mask: { type: 'contains', filter: this.filterRole },
        status: { type: 'contains', filter: this.filterStatus },
      };

      this.gridApi.setFilterModel(filterModel);
    }
  }

  onSelectionRole(event: any) {
    if (this.gridApi) {
      if (event.value == 'All') {
        this.filterRole = '';
      }
      else {
        this.filterRole = event.value;
      }
      const filterModel = {
        email: { type: 'contains', filter: this.filterUsername },
        roles_mask: { type: 'contains', filter: this.filterRole },
        status: { type: 'contains', filter: this.filterStatus },
      };
      this.gridApi.setFilterModel(filterModel);
    }
  }

  onSelectionStatus(event: any) {
    if (this.gridApi) {
      if (event.value == 'All') {
        this.filterStatus = '';
      }
      else {
        this.filterStatus = event.value;
      }
      const filterModel = {
        email: { type: 'contains', filter: this.filterUsername },
        roles_mask: { type: 'contains', filter: this.filterRole },
        status: { type: 'contains', filter: this.filterStatus },
      };
      this.gridApi.setFilterModel(filterModel);
    }
  }

  addUser() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '700px'; // You can use pixels or other units
    dialogConfig.height = '800px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Add New User',
        modalMessage: this.apiUsers,
      },
    };
    this.dialog.open(UserModalComponent, dialogConfig);
  }

}
